import React from 'react'

function Adminpage() {
  return (
    <div>
        
            {/* {facilityId === undefined
                ? <p></p>
                :<Complaints/>
            } */}
    </div>
  )
}

export default Adminpage